import { Card, CardContent } from "../../../client/components/ui/card";
import { CardSectionHeader } from "../../../client/components/ui/card-section-header";
import { usePfmData } from "../../../prop-firm-manager/PfmDataContext";
import PayoutsAnalyticsSection from "../../../prop-firm-manager/PayoutsAnalyticsSection";

export default function PropFirmAccountsTableWidget() {
  const { filteredAccounts, isDark, t } = usePfmData();
  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.analytics.payoutsPerAccount} isDark={isDark} compact />
      <CardContent className="flex-1 overflow-auto p-4">
        <PayoutsAnalyticsSection
          accounts={filteredAccounts}
          isDark={isDark}
          sections={{ reporting: false, accountsTable: true, globalCharges: false }}
          hideTitle
          editable
        />
      </CardContent>
    </Card>
  );
}
